// The foloowing values come from environment variables set in the docker image by ecs-deployments.
// Below values are set in env.template.js in the DockerFile by envsubst when the container starts

export const environment = {
    production: window["env"]["is_production"] || false,
    api_url: window["env"]["api_url"] || 'http://localhost:5003',
    transportapi_url: window["env"]["transportapi_url"] || 'https://api-transport.dev.mtdata.com.au/',
    emailapi_url: window["env"]["email_api_url"] || 'https://api-email.dev.mtdata.com.au/',
    authr_login_url: window["env"]["authr_login_url"] || 'https://authr-qa.mtdata.be/login',
    recaptcha_sitekey: window["env"]["recaptcha_sitekey"] || '6LelKTIaAAAAAF6CC4bOn6ictuzZH2bE7Vv_XL1V',
    allow_delete: window["env"]["allow_delete"] || false,
    version: '/api/v1/'
};
